export default __webpack_public_path__ + "static/media/i3.ee05cbe2.png";